import { render, staticRenderFns } from "./KarmaCatalogueEditForm.vue?vue&type=template&id=ffa8661a&"
import script from "./KarmaCatalogueEditForm.vue?vue&type=script&lang=js&"
export * from "./KarmaCatalogueEditForm.vue?vue&type=script&lang=js&"
import style0 from "./KarmaCatalogueEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports